import { FullScreenContentModal } from 'V2Components'
import { getHTMLDataTestID } from 'infra/utils'
import { Button, Label, LoadingSpinner, TargetIcon, TextInput, Typography } from 'procyon-ui'
import React from 'react'

const MSTeam = ({ onInputChange, onContinue, message, isDisabled, onCancel, nameError }) => {
  return (
    <FullScreenContentModal>
      <div className='flex justify-between items-center'>
        <Typography variant='title-regular' className='flex text-2xl items-center font-bold'>
          <TargetIcon
            width={'48px'}
            height={'48px'}
            type={'TEAMS'}
            className='rounded'
            style={{
              borderRadius: '12px',
              marginRight: '15px'
            }}
          />
          Setup Microsoft Team Integration
        </Typography>
      </div>
      {!message ? (
        <>
          <div className='p-4 mt-2 rounded text-black max-h-[60vh] w-[100%]'>
            <TextInput
              label='Integration Name'
              data-testid={getHTMLDataTestID('integration', 'input', 'name')}
              onChange={(e) => onInputChange(e.target.value, 'name')}
              placeholder='Please enter name'
              style={{
                width: '550px',
                marginBottom: '20px'
              }}
            />

            <TextInput
              data-testid={getHTMLDataTestID('integration', 'input', 'webhookurl')}
              label='Webhook Url'
              onChange={(e) => onInputChange(e.target.value, 'webhookurl')}
              placeholder='URL'
              style={{
                width: '550px'
              }}
            />
          </div>

          <div className='flex justify-between px-4 items-center'>
            <div>{nameError !== '' ? <Label variant='warning' text={nameError} /> : null}</div>
            <div className='flex justify-end gap-4'>
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'cancel')}
                size='md'
                onClick={onCancel}
                variant='gray'
              >
                Cancel
              </Button>
              <Button
                data-testid={getHTMLDataTestID('integration', 'button', 'continue')}
                size='md'
                onClick={onContinue}
                variant='primary'
                disabled={isDisabled}
              >
                Continue
              </Button>
            </div>
          </div>
        </>
      ) : (
        <div className='flex items-center bg-[#f2f4fb] p-5 mt-5'>
          <div className='mt-2'>
            <LoadingSpinner size={20} thickness={4} />
          </div>
          <Label text={message} variant='grayBlue' />
        </div>
      )}
    </FullScreenContentModal>
  )
}

export { MSTeam }
